import React, { useRef, useState, useEffect } from "react";
import { Eraser, Check } from "lucide-react";
import { Button } from "./ui/button";

// Touch/mouse signature pad. Calls onSave(dataUrl) or onChange(hasInk).
export default function SignaturePad({ onSave, onClear }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0f2847";
  }, []);

  const pos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); setHasInk(true); };
  const end = () => { drawing.current = false; };

  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setHasInk(false);
    onClear && onClear();
  };
  const save = () => { if (!hasInk) return; onSave(canvasRef.current.toDataURL("image/png")); };

  return (
    <div>
      <canvas
        ref={canvasRef}
        data-testid="signature-canvas"
        className="w-full h-40 rounded-xl border-2 border-dashed border-slate-300 bg-slate-50 touch-none"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      <div className="mt-2 flex gap-2">
        <Button type="button" onClick={clear} variant="outline" size="sm" className="rounded-full h-9 px-4 font-semibold border-2" data-testid="signature-clear">
          <Eraser className="w-4 h-4 mr-1.5" /> Clear
        </Button>
        <Button type="button" onClick={save} disabled={!hasInk} size="sm" className="rounded-full h-9 px-4 font-semibold bg-[#0f2847] text-white disabled:opacity-50" data-testid="signature-save">
          <Check className="w-4 h-4 mr-1.5" /> Save signature
        </Button>
      </div>
    </div>
  );
}
